export default __webpack_public_path__ + "static/media/harbour.82a841e6.png";